import { Component, computed, input, inject } from '@angular/core';
import { ToggleMenuService } from '../../../../../shared/services/toggle-menu.service';
import { MenuItem } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { Menu, MenuModule } from 'primeng/menu';
import { UserRole } from '../../../../../core/auth/enums/userRoles';

interface Action {
  label: string | undefined;
  icon: string | undefined;
  actionKey: string;
  isDisabled: boolean;
  isVisible: boolean;
}

@Component({
  selector: 'app-ride-actions',
  standalone: true,
  imports: [MenuModule, DialogModule],
  templateUrl: './ride-actions.component.html',
  styleUrl: './ride-actions.component.scss',
})
export class RideActionsComponent {
  private readonly toggleMenuService = inject(ToggleMenuService);

  readonly favoriteActions = input<Action[]>([]);
  readonly rideActionsMap = input.required<{
    [key: string]: {
      command: Function;
      isVisibleFunction: Function;
      isDisabledFunction: Function;
    };
  }>();

  readonly actionsMenuItems_1 = input<MenuItem[]>([]);
  readonly actionsMenuItems_2 = input<MenuItem[]>([]);
  readonly actionsMenuItems_3 = input<MenuItem[]>([]);

  readonly visibleActionsMenuItems_1 = computed(() => this.actionsMenuItems_1().filter(item => item.visible !== false));
  readonly visibleActionsMenuItems_2 = computed(() => this.actionsMenuItems_2().filter(item => item.visible !== false));
  readonly visibleActionsMenuItems_3 = computed(() => this.actionsMenuItems_3().filter(item => item.visible !== false));

  readonly allActionsMenuItems = computed(() => [...this.visibleActionsMenuItems_1(), ...this.visibleActionsMenuItems_2(), ...this.visibleActionsMenuItems_3()]);

  showActionsMenuDialog = false;
  currentActiveMenu!: MenuItem[] | null;

  UserRole = UserRole;
  currentRole = (localStorage.getItem('role') ?? '').toLowerCase();

  openMenu(event: Event, menu: Menu, btn?: HTMLElement) {
    btn?.classList.add('active-menu-btn');
    this.toggleMenuService.openMenu(menu, event);
  }

  showActionsMenu(event: Event, menu: Menu, btn?: HTMLElement) {
    if (window.innerWidth > 768) {
      this.openMenu(event, menu, btn);
    } else {
      this.showActionsMenuDialog = true;
      this.currentActiveMenu = menu.model ?? null;
    }
  }

  test(e: any, item: MenuItem) {
    console.log(e);
    console.log(item);
    console.log(item.command);
    if (item.command) {
      item.command({ item });
    }
  }

  RemoveBtnActiveClass(btn: HTMLElement) {
    console.log(btn);
    btn.classList.remove('active-menu-btn');
  }
}
